"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var foundation_1 = require("../../theme/foundation");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var buttons_1 = require("../buttons");

exports.Toast = utils_2.forwardRef(function Grid(props, ref) {
  var duration = props.duration,
      type = props.type,
      title = props.title,
      text = props.text,
      closeLabel = props.closeLabel,
      onClose = props.onClose,
      closable = props.closable,
      sticky = props.sticky,
      icon = props.icon,
      _a = props.toastPosition,
      toastPosition = _a === void 0 ? 'top-right' : _a;

  var _b = React.useState(false),
      visibleToast = _b[0],
      setVisibleToast = _b[1];

  var _c = React.useState(false),
      removeToast = _c[0],
      setRemoveToast = _c[1];

  React.useEffect(function () {
    setTimeout(function () {
      setVisibleToast(true);

      if (!closeLabel && !onClose) {
        setTimeout(function () {
          setVisibleToast(false);
          setTimeout(function () {
            setRemoveToast(true);
          }, 200);
        }, duration || 3000);
      }
    }, 100);
  }, []);
  var toastContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t {\n\t\t\tposition: fixed;\n\t\t\tpadding: 1rem;\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\tcolor: ", ";\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\tz-index: 100;\n\t\t\tbackground: ", ";\n\t\t\tdisplay: ", ";\n\t\t\tbox-shadow: 0 0.313em 0.625em rgba(66, 85, 99, 0.25);\n\n\t\t\twidth: 100%;\n\t\t\tmax-width: 300px;\n\t\t\tbackground: ", ";\n\t\t\tborder-radius: 0.5em;\n\t\t\tline-height: 150%;\n\n\t\t\tcolor: ", ";\n\t\t\tborder: solid 1px ", ";\n\t\t\tfont-size: 0.75em;\n\n\t\t\ttransition: all 0.2s ease-in-out;\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tposition: fixed;\n\t\t\tpadding: 1rem;\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\tcolor: ", ";\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\tz-index: 100;\n\t\t\tbackground: ", ";\n\t\t\tdisplay: ", ";\n\t\t\tbox-shadow: 0 0.313em 0.625em rgba(66, 85, 99, 0.25);\n\n\t\t\twidth: 100%;\n\t\t\tmax-width: 300px;\n\t\t\tbackground: ", ";\n\t\t\tborder-radius: 0.5em;\n\t\t\tline-height: 150%;\n\n\t\t\tcolor: ", ";\n\t\t\tborder: solid 1px ", ";\n\t\t\tfont-size: 0.75em;\n\n\t\t\ttransition: all 0.2s ease-in-out;\n\t\t}\n\t"])), toastPosition === 'top-left' && 'left: 1rem;', toastPosition === 'top-left' && 'top: 1rem;', toastPosition === 'top-right' && 'right: 1rem;', toastPosition === 'top-right' && 'top: 1rem;', toastPosition === 'bottom-left' && 'left: 1rem;', toastPosition === 'bottom-left' && 'bottom: 1rem;', toastPosition === 'bottom-right' && 'right: 1rem;', toastPosition === 'bottom-right' && 'bottom: 1rem;', type && type === 'info' ? foundation_1.colors.secondary.darkGrey : foundation_1.colors.white, foundation_1.colors.white, removeToast ? 'none' : 'flex', foundation_1.colors.white, foundation_1.colors.secondary.grey, foundation_1.colors.graphical.strokes);
  var actionButton = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 50px;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tsvg {\n\t\t\t\t\ttransform: scale(1.1);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 50px;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tsvg {\n\t\t\t\t\ttransform: scale(1.1);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"])));
  var iconStyle = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\twidth: 2em;\n\t\theight: 100%;\n\t\tjustify-content: flex-start;\n\t\tdisplay: flex;\n\t\talign-self: flex-start;\n\t\tpadding-top: 0.5em;\n\t"], ["\n\t\twidth: 2em;\n\t\theight: 100%;\n\t\tjustify-content: flex-start;\n\t\tdisplay: flex;\n\t\talign-self: flex-start;\n\t\tpadding-top: 0.5em;\n\t"])));
  var contentStyle = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\twidth: calc(100% - 2em);\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\tflex-direction: column;\n\t\ttext-align: left;\n\t"], ["\n\t\twidth: calc(100% - 2em);\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\tflex-direction: column;\n\t\ttext-align: left;\n\t"])));
  var contentStyleTitle = core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\ttext-align: left;\n\t\tfont-weight: 800;\n\t\tfont-size: 12px;\n\t"], ["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\ttext-align: left;\n\t\tfont-weight: 800;\n\t\tfont-size: 12px;\n\t"])));
  var contentStyleText = core_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\ttext-align: left;\n\t\tfont-size: 12px;\n\t\tmargin-top: 0.5em;\n\t"], ["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\ttext-align: left;\n\t\tfont-size: 12px;\n\t\tmargin-top: 0.5em;\n\t"])));
  var contentStyleAction = core_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\ttext-align: left;\n\t\tfont-size: 12px;\n\t\tmargin-top: 1em;\n\t"], ["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\ttext-align: left;\n\t\tfont-size: 12px;\n\t\tmargin-top: 1em;\n\t"])));
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: toastContainer
  }, icon && (0, _core.jsx)(lseds_1.lseds.div, {
    css: iconStyle
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: icon
  })), (0, _core.jsx)(lseds_1.lseds.div, {
    css: contentStyle
  }, title && (0, _core.jsx)(lseds_1.lseds.div, {
    css: contentStyleTitle
  }, title), (0, _core.jsx)(lseds_1.lseds.div, {
    css: contentStyleText
  }, text), closeLabel && (0, _core.jsx)(lseds_1.lseds.div, {
    css: contentStyleAction
  }, (0, _core.jsx)(buttons_1.Button, {
    label: closeLabel,
    onClick: onClose,
    wired: true
  }))));
});

if (utils_1.isDev) {
  exports.Toast.displayName = 'Toast';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;